var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M26.679 23.805c6.216-1.417 6.607-11.534 10.195-12.52-7.445-1.228-10.975 1.976-12.908 8.988-1.917-6.9-5.658-10.367-12.755-8.966 3.84.964 3.51 10.606 10.025 12.495-5.024 0-5.396 11.573-10.236 12.914 7.577 1.288 11.182-2.572 12.966-9.35C25.794 34.136 29.869 37.989 37 36.78c-4.749-.453-4-12.978-10.324-12.978"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 11,
    x2: 37,
    y1: 23.987,
    y2: 23.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19636B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniferIcon);
export default __webpack_public_path__ + "static/media/uniferIcon.1bb5c3c02f5b2e23f6d3dc9f63e92ec4.svg";
export { ForwardRef as ReactComponent };